<template>
    <div class="home">
      <p>hello news detail</p>
    </div>
</template>